import { FieldMergeFunction } from '@apollo/client'

import { Mortgage } from '@acre/graphql'

const merge: FieldMergeFunction<Mortgage[]> = (existing, incoming) => {
  return incoming
}

export default {
  merge,
}
